import { Injectable } from '@angular/core';
import { APP } from 'src/app/config/app';
import { CommunicationType, CommunicationUserType, UserRole } from 'src/app/models/enums';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class HomeRouteService {
  private readonly communicationSections: string[] = [CommunicationType.SUGGESTIONS, CommunicationType.MESSAGES];

  constructor(private storageService: StorageService) {}

  async getHomeRoute(): Promise<string> {
    const lastSection = localStorage.getItem(APP.LOCAL_STORAGE_LAST_ROUTE) || APP.DEFAULT_ROUTE;
    if (!this.communicationSections.includes(lastSection)) return lastSection;
    const role = await this.storageService.getRole();
    return `${lastSection}/${await this.getSuggestionsListType(role)}`;
  }

  async getSuggestionsListType(role: UserRole): Promise<CommunicationUserType> {
    return this.getListType(role, () => this.storageService.getSuggestionsLastListType());
  }

  async getUsersListType(role: UserRole): Promise<CommunicationUserType> {
    return this.getListType(role, () => this.storageService.getUsersLastListType());
  }

  private async getListType(
    role: UserRole,
    getLastListType: () => Promise<CommunicationUserType | null>,
  ): Promise<CommunicationUserType> {
    if (role === UserRole.SUPERADMIN || role === UserRole.ADMIN) {
      return (await getLastListType()) ?? CommunicationUserType.USERS;
    }
    return role === UserRole.DRIVER_MANAGER ? CommunicationUserType.DRIVERS : CommunicationUserType.USERS;
  }
}
